import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

import { useBaseInputController } from './index.controller';
import { getMinimalVariantStyles, getPopperStyles } from './index.styles';
import { BaseInputProps } from './index.types';

export function BaseInputView(props: BaseInputProps) {
  const {
    displayValue,
    variant,
    options,
    isDisabled,
    readonly,
    rest,
    handleChange,
    handleInputChange,
    getOptionLabel,
  } = useBaseInputController(props);

  const { sx, ...restProps } = rest;

  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={options?.map((x) => x.value) ?? []}
      getOptionLabel={getOptionLabel}
      fullWidth
      disabled={isDisabled}
      value={displayValue}
      inputValue={displayValue ?? ''}
      onChange={handleChange}
      onInputChange={handleInputChange}
      renderInput={(params) => (
        <TextField
          {...restProps}
          {...params}
          variant={variant}
          multiline
          InputProps={{
            ...restProps.InputProps,
            ...params.InputProps,
            readOnly: readonly,
          }}
          sx={{
            ...sx,
            minWidth: 200,
          }}
        />
      )}
      sx={{
        ...sx,
        ...(props.variant === 'minimal' ? getMinimalVariantStyles() : {}),
      }}
      slotProps={{
        popper: {
          sx: getPopperStyles(),
        },
      }}
    />
  );
}
